module.exports = __webpack_public_path__ + "static/media/29ADMSPC28.f2b582df.jpg";